<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" class="p-button-danger" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-4xl">Condizione lavorativa attuale</label>
</div>

<div class="flex align-items-start flex-column
            lg:flex-row lg:justify-content-between bg-dashboard bg-shadow
             p-5 border-radius-right-dashboard col-8
            sm:flex-row col-11">
  <div class="flex align-items-start flex-column md:flex-row w-full">
    <div class="col-2">
      <p-avatar image="assets/img/icona-azienda.jpg" shape="circle" size="xlarge"></p-avatar>
    </div>
    <div class="col-10 flex flex-wrap" *ngIf="workExperiences.length == 0">
      <div class="w-full colorTm">
        <label class="w-full text-2xl">Nessun Lavoro Inserito</label>
      </div>
    </div>
    <div class="col-10 flex flex-wrap" *ngIf="workExperiences.length >0">
      <div class="w-full colorTm">
        <label class="w-full text-2xl">{{currentWorkExperience.Professione}} presso <label
          class="font-bold">{{currentWorkExperience.Azienda}}</label></label>
      </div>
      <div class="w-full mt-5 flex colorTm">
        <label class="font-bold">Contratto</label>
        <label class="ml-2">{{currentWorkExperience.TipoContrattoDesc}} avviato
          il {{currentWorkExperience.DataInizioStr}}</label>
      </div>
    </div>



  </div>
</div>

<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-2xl">Precedentemente hai lavorato presso</label>

  <div class="w-full mt-5">
    <ul class="list-none p-0 m-0 w-full">
      <li
        class="flex w-full align-content-center mb-3"
        *ngFor="let workExperience of workExperiences; index as i">
        <div class="col-10 md:col-11 flex flex-column md:flex-row align-items-center md:justify-content-between p-0 border-1 sharedListTemplate">
          <div class="col-1 flex">
            <p-avatar image="assets/img/icona-azienda.jpg" shape="circle" class="flex"></p-avatar>
          </div>
          <div class="col-12 lg:col-4 flex align-content-center flex-wrap ml-2">
            <label class="w-full flex sm:align-content-center font-bold sm:text-center" style="overflow: hidden;">{{workExperience.Azienda.toUpperCase()}}</label>
          </div>
          <div class="col-12 lg:col-4 flex align-content-center flex-wrap ml-2">
            <label class="w-full flex align-content-center" style="overflow: hidden;">{{workExperience.TipoContrattoDesc.toUpperCase()}}</label>
          </div>
          <div class="col-12 lg:col-2 flex align-content-center justify-content-center">
            <label class="flex align-content-center">{{workExperience.DataInizioStr}} - {{workExperience.DataFineStr}}</label>
          </div>
        </div>
        <div class="col-2 lg:col-2 flex align-content-center flex-wrap">
          <div class="col-12 flex align-content-center buttonIcon">
            <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-rounded p-button-outlined mr-2 mt-1"
                    (click)="editWorkExperience(workExperience)"></button>
            <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-danger mt-1"
                    (click)="deleteWorkExperience(workExperience.IdAnagraficaUtenteEspProf)" ></button>
          </div>
        </div>
      </li>
    </ul>
    <button pButton pRipple label="Aggiungi esperienza di lavoro"
            class="mt-4 w-full p-button-rounded p-3 btnAddWork font-bold"
            icon="pi pi-plus" iconPos="left"
            (click)="insertNewWorkExperience()"></button>
  </div>
</div>

<p-dialog [header]="headerDialog" [(visible)]="showDialog" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">

  <div class="col-12 flex flex-wrap">
    <div class="col-12 flex">
      <label class="labelWidth">Condizione lavorativa *</label>
      <select class="w-full" pInputText style="appearance: auto"
              [(ngModel)]="workExperienceSelected.TipoContratto">
        <option *ngFor="let item of occupationTypesList; let i = index" [ngValue]="item.Key">{{item.Value}}</option>
        <option [ngValue]="0"></option>
      </select>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">Periodo da</label>
      <p-calendar [(ngModel)]="workExperienceSelected.DataInizio"
                  view="month" dateFormat="mm/yy"
                  [readonlyInput]="true" inputId="monthpicker"
                  styleClass="w-full" class="w-full" appendTo="body"></p-calendar>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">In corso</label>
      <p-inputSwitch [(ngModel)]="workExperienceSelected.InCorso" class="w-full"
                     (onChange)="changeInCorso()"></p-inputSwitch>
    </div>
    <div class="col-12 flex" *ngIf="!workExperienceSelected.InCorso">
      <label class="labelWidth">Periodo a</label>
      <p-calendar [(ngModel)]="workExperienceSelected.DataFine"
                  view="month" dateFormat="mm/yy"
                  [readonlyInput]="true" inputId="monthpicker"
                  styleClass="w-full" class="w-full" appendTo="body"></p-calendar>
    </div>
    <div class="col-12 flex" *ngIf="workExperienceSelected.TipoContratto == 3">
      <label class="labelWidth">Agenzia somministrazione *</label>
      <p-autoComplete [(ngModel)]="aplSelected"
                      [suggestions]="aplList"
                      field="AplDesc"
                      (completeMethod)="getAplList($event)"
                      styleClass="w-full"
                      class="w-full"
                      appendTo="body"
                      [dropdown]="true"
                      name="task"
                      [required]="true">
        <ng-template let-apl pTemplate="item">
          <div class="person-item">
            <div>{{apl.AplDesc}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">Azienda *</label>
      <input id="company"
             type="text"
             pInputText
             class="w-full"
             name="company"
             [(ngModel)]="workExperienceSelected.Azienda">
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">Mansione *</label>
      <span class="p-fluid w-full">
              <p-autoComplete [(ngModel)]="taskSelected"
                              [suggestions]="taskList"
                              field="MansioneDesc"
                              (completeMethod)="getTaskList($event)"
                              styleClass="w-full"
                              class="w-full"
                              appendTo="body"
                              name="task"
                              [multiple]="true">
        <ng-template let-task pTemplate="item">
          <div class="person-item">
            <div>{{task.MansioneDesc.toUpperCase()}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
      </span>
    </div>
    <div class="col-12 field">
      <label class="w-full">Descrizione mansione</label>
      <textarea class="w-full" pStyleClass="w-full" pInputTextarea
                [autoResize]="true"
                [(ngModel)]="workExperienceSelected.DescrizioneEsperienzaLavorativa"></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="col-12 flex flex-wrap justify-content-end">
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Annulla" class="mt-4 w-full p-button-rounded p-button-secondary"
                (click)="closeModal()"></button>
      </div>
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Salva" class="mt-4 w-full p-button-rounded"
                (click)="workExperienceUpsert()"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
